import { render, staticRenderFns } from "./ConsultingList.vue?vue&type=template&id=240d16c0&scoped=true&"
import script from "./ConsultingList.vue?vue&type=script&lang=js&"
export * from "./ConsultingList.vue?vue&type=script&lang=js&"
import style0 from "./ConsultingList.vue?vue&type=style&index=0&id=240d16c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d16c0",
  null
  
)

export default component.exports